import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { useMediaQuery } from "react-responsive";
import ImageShatter from '../Effects/ImageShatter/ImageShatter';
import './Reasons.css'
import { sanityClient } from '../../sanity/client';
import { reasonsQuery } from '../../sanity/queries';
import fmt from "../../assets/FMT.png";
import wtf from "../../assets/WTF.png";


const Reasons = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const is900 = useMediaQuery({ maxWidth: 900 })

  const [data, setData] = useState(null);

  useEffect(() => {
    sanityClient.fetch(reasonsQuery).then(setData);
  }, []);

  if (!data) return null;

  let height = '100%';

  if(is900 && !isMobile){
    height = '285px';
  }
  if(isMobile){
    height = '200px';
  }
    return (
      <motion.div
       className="Reasons" id="reasons"
       initial = {{ opacity: 0, y: 30, scale: 0.96}}
       whileInView = {{ opacity: 1, y: 0, scale: 1}} 
       viewport = {{ once: false}} 
       transition = {{ duration: 0.8, ease: "linear" }}>
        <div className="reasons-header">
          <span>{data.subtitle}</span>
          <div>
            <span className="stroke-text">{data.title.strokeText} </span>
            <span>{data.title.normalText}</span>
          </div>
        </div>
        <div className="left-r">
          <ImageShatter
            images={data.carouselImages}
            // width={768}
            height={height}
          />
        </div>
        
        {data.showClip && (
        <div className="item-clip-shape">
          <div className="clip-content">
            <div className="item-discount">{data.clipLines.clipTopText}</div>
            <div className="items-off">{data.clipLines.clipMiddleText}</div>
            <div className="item-member">{data.clipLines.clipBottomText}</div>
          </div>
        </div>
        )}
        
        <div className="reasons-list">
          <ul>
            {data.reasons.map((reason, i) => (
              <li key={i}>
                <img 
                src={reason.icon}
                alt={reason.icon}
                className='icon'
                />
                <span>{reason.text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bottomRight">
          <span className="partnersLetter">Reconocidos por</span>
          <div className="partners">
            <img src={fmt} alt="" />
            <img src={wtf} alt="" />
          </div>
        </div>
      </motion.div>
    );
}

export default Reasons